module.exports = __webpack_public_path__ + "img/marker_three_blue1.5515d9f1.png";